import { render, staticRenderFns } from "./Sidebartem.vue?vue&type=template&id=f96a06fa"
import script from "./Sidebartem.vue?vue&type=script&lang=ts"
export * from "./Sidebartem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96a06fa')) {
      api.createRecord('f96a06fa', component.options)
    } else {
      api.reload('f96a06fa', component.options)
    }
    module.hot.accept("./Sidebartem.vue?vue&type=template&id=f96a06fa", function () {
      api.rerender('f96a06fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/Sidebartem.vue"
export default component.exports